import { z } from 'zod'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v1/pagination'

export const searchResultSchema = z.object({
    company_uuid: z.string().uuid().nullable(),
    created_at: z.coerce.date(),
    is_active: z.boolean(),
    label: z.string(),
    name: z.string(),
    priority: z.number(),
    title: z.string(),
    type: z.string(),
    updated_at: z.coerce.date(),
    url: z.string().url().nullable(),
    uuid: z.string().uuid(),
})

export const searchResultsSchema = z.array(searchResultSchema)

export const paginatedSearchResultsSchema = z.object({
    data: searchResultsSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})
